import { render, staticRenderFns } from "./PromotionConditionActions.vue?vue&type=template&id=bb737db6&"
import script from "./PromotionConditionActions.vue?vue&type=script&lang=ts&"
export * from "./PromotionConditionActions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports